const Order = require('@/lib/Orders/Order');
const { populate } = require('@/functions/objects');
const { toBool, toString } = require('../../../../functions/transform');

/**
 * @param {object} [data]
 *
 * @constructor
 */
const OrderAdjustmentResponse = function (data = {}) {
    /**
     * @type {?boolean}
     */
    this.success = null;

    /**
     * @type {?string}
     */
    this.message = null;

    /**
     * The adjustment order that was just created (a diff/delta from the original order to the desired state).
     *
     * @type {Order}
     */
    this.adjustmentOrder = null;

    /**
     * The complete new order after adjustments have been applied.
     *
     * @type {Order}
     */
    this.adjustedOrder = null;

    /**
     * This isn't returned from the API in the final spec of the adjustments endpoint, but we can
     * set it from the original order model we already had.
     *
     * @type {Order}
     */
    this.originalOrder = null;

    populate(this, data);
};

OrderAdjustmentResponse.prototype = {
    getHydrationMap() {
        return {
            success: toBool,
            message: toString,
            adjustmentOrder: {
                model: Order,
            },
            adjustedOrder: {
                model: Order,
            },
            originalOrder: {
                model: Order,
            },
        };
    },

    /**
     * @return {boolean}
     */
    orderIsFullyCancelled() {
        return this.adjustedOrder.getTotalQty() === 0;
    },
};

module.exports = OrderAdjustmentResponse;
